// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-container {
  display: flex;
  flex:1 1;
  flex-direction: column;
  align-items: center;
  /* margin-top: 50px; */
  font-family: Arial, sans-serif;
}

.question-section {
  margin-bottom: 20px;
}

.question-count {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  font-size: xx-large;
  font-weight: bolder;
  margin-bottom: 10px;
}

.add-question-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #97e4b5;
  cursor: pointer;
  padding: 3px;
}

.delete-question-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #e49797;
  cursor: pointer;
  padding: 3px;
}

.change-question-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #e7e7e7;
  cursor: pointer;
  padding: 3px;
}
.change-question-button:hover {
  background-color: #a3a3a3;
}

.change-question-button.disabled {
  opacity: .5;
}


.modify-questions-button-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.modify-questions-button-container.disabled {
  opacity: .4;
  pointer-events: none;
}

.modify-question-buttons-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-evenly;
  margin-bottom: 50px;
  /* width: 800px; */
}

@media (min-width: 800px) {
  .modify-question-buttons-container {
     width: 800px;

  }
}

.modify-question-button-text {
  font-weight: bolder;
  font-size: x-small;
}

.question-text {
  margin-bottom: 20px;
  font-size: 24px;
  font-style: italic;
}

.answer-section button {
  width: 100%;
  margin: 5px 0;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
}

.answer-section button:hover {
  background-color: #e9e9e9;
}

.score-section {
  font-size: 24px;
}

.quiz-editor-container {
  flex:1 1;
  display: flex;
  margin: 10px;
}

.front-back-button-row {
  display: flex;
  gap: 5px;
  justify-content: center;
}

.quiz-answer {
  margin: 5px 0;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  border: 1px solid #ddd;
  background-color: #f9f9f9
}

.quiz-answer.correct{
  margin: 5px 0;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  border: 1px solid #ddd;
  background-color: #befed5
}
.quiz-edit-field-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
}

.quiz-edit-field-close {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: #e49797;
  cursor: pointer;
  padding: 3px;
}

.quiz-edit-field-close:hover {
  background-color: #cc6969;
}

.quiz-edit-field-save {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: #97e4b5;
  cursor: pointer;
  padding: 3px;
}

.quiz-edit-field-save:hover {
  background-color: #69cc8e;
}

.quiz-container-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  font-family: Arial, sans-serif;
  justify-content: center;
}

.quiz-edit-field-buttons-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
}
.add-questions-cta {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: #97c9e4;
  padding: 30px;
  font-size: x-large;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Quiz/Quiz.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAM;EACN,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;KACG,YAAY;;EAEf;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,QAAM;EACN,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB","sourcesContent":[".quiz-container {\n  display: flex;\n  flex:1;\n  flex-direction: column;\n  align-items: center;\n  /* margin-top: 50px; */\n  font-family: Arial, sans-serif;\n}\n\n.question-section {\n  margin-bottom: 20px;\n}\n\n.question-count {\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  gap: 10px;\n  font-size: xx-large;\n  font-weight: bolder;\n  margin-bottom: 10px;\n}\n\n.add-question-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  background-color: #97e4b5;\n  cursor: pointer;\n  padding: 3px;\n}\n\n.delete-question-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  background-color: #e49797;\n  cursor: pointer;\n  padding: 3px;\n}\n\n.change-question-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  background-color: #e7e7e7;\n  cursor: pointer;\n  padding: 3px;\n}\n.change-question-button:hover {\n  background-color: #a3a3a3;\n}\n\n.change-question-button.disabled {\n  opacity: .5;\n}\n\n\n.modify-questions-button-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.modify-questions-button-container.disabled {\n  opacity: .4;\n  pointer-events: none;\n}\n\n.modify-question-buttons-container {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  justify-content: space-evenly;\n  margin-bottom: 50px;\n  /* width: 800px; */\n}\n\n@media (min-width: 800px) {\n  .modify-question-buttons-container {\n     width: 800px;\n\n  }\n}\n\n.modify-question-button-text {\n  font-weight: bolder;\n  font-size: x-small;\n}\n\n.question-text {\n  margin-bottom: 20px;\n  font-size: 24px;\n  font-style: italic;\n}\n\n.answer-section button {\n  width: 100%;\n  margin: 5px 0;\n  padding: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  border: 1px solid #ddd;\n  background-color: #f9f9f9;\n}\n\n.answer-section button:hover {\n  background-color: #e9e9e9;\n}\n\n.score-section {\n  font-size: 24px;\n}\n\n.quiz-editor-container {\n  flex:1;\n  display: flex;\n  margin: 10px;\n}\n\n.front-back-button-row {\n  display: flex;\n  gap: 5px;\n  justify-content: center;\n}\n\n.quiz-answer {\n  margin: 5px 0;\n  padding: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  border: 1px solid #ddd;\n  background-color: #f9f9f9\n}\n\n.quiz-answer.correct{\n  margin: 5px 0;\n  padding: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  border: 1px solid #ddd;\n  background-color: #befed5\n}\n.quiz-edit-field-container {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  justify-content: space-between;\n}\n\n.quiz-edit-field-close {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background-color: #e49797;\n  cursor: pointer;\n  padding: 3px;\n}\n\n.quiz-edit-field-close:hover {\n  background-color: #cc6969;\n}\n\n.quiz-edit-field-save {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background-color: #97e4b5;\n  cursor: pointer;\n  padding: 3px;\n}\n\n.quiz-edit-field-save:hover {\n  background-color: #69cc8e;\n}\n\n.quiz-container-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n  font-family: Arial, sans-serif;\n  justify-content: center;\n}\n\n.quiz-edit-field-buttons-container {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  justify-content: center;\n}\n.add-questions-cta {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 5px;\n  background-color: #97c9e4;\n  padding: 30px;\n  font-size: x-large;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
